import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=6b273cd7&"
import script from "./Birthday.vue?vue&type=script&lang=js&"
export * from "./Birthday.vue?vue&type=script&lang=js&"
import style0 from "./Birthday.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Birthday.vue"
export default component.exports